import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/hospitals-income/`;

export const hospitalIncome = {
  get: () => generateApiPath(pathBase),
};
